import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";

import App from "./App";

// Quando publicamos uma versao nova, quem esta com a aba aberta continua com o
// codigo antigo e pode pedir um pedaco do app que nao existe mais. Antes isso
// virava tela branca sem explicacao. Agora o servidor devolve 404 e a gente
// recarrega uma unica vez para pegar a versao nova.
// A trava no sessionStorage evita laco infinito se a falha for outra.
const CHAVE_RELOAD = "recarregouPorDeploy";

const pareceFalhaDeVersao = (texto) => {
  const t = String(texto || "");
  return (
    t.indexOf("Loading chunk") !== -1 ||
    t.indexOf("Loading CSS chunk") !== -1 ||
    t.indexOf("ChunkLoadError") !== -1 ||
    (t.indexOf("Unexpected token") !== -1 && t.indexOf("<") !== -1)
  );
};

const recarregarUmaVez = (motivo) => {
  try {
    if (sessionStorage.getItem(CHAVE_RELOAD)) return;
    sessionStorage.setItem(CHAVE_RELOAD, "1");
  } catch (e) {
    return; // navegador sem sessionStorage: melhor nao recarregar do que entrar em laco
  }
  console.warn("[versao] recarregando para pegar a versao nova:", motivo);
  window.location.reload();
};

window.addEventListener("error", (evento) => {
  const alvo = evento?.target;
  // falha ao baixar <script> ou <link> do proprio app
  if (alvo && (alvo.tagName === "SCRIPT" || alvo.tagName === "LINK")) {
    const url = alvo.src || alvo.href || "";
    if (url.indexOf("/static/") !== -1) recarregarUmaVez("asset " + url);
    return;
  }
  if (pareceFalhaDeVersao(evento?.message)) recarregarUmaVez(evento.message);
}, true);

window.addEventListener("unhandledrejection", (evento) => {
  if (pareceFalhaDeVersao(evento?.reason?.message || evento?.reason)) {
    recarregarUmaVez("promise");
  }
});

// Carregou inteiro: limpa a trava para que um proximo deploy possa recarregar
window.addEventListener("load", () => {
  try {
    sessionStorage.removeItem(CHAVE_RELOAD);
  } catch (e) { /* modo privado */ }
});

// Registrar Service Worker para suporte a Web Push no PWA
if ('serviceWorker' in navigator) {
	window.addEventListener('load', () => {
		navigator.serviceWorker.register('/service-worker.js')
			.then((reg) => {
				console.log('[SW] Registrado com sucesso:', reg.scope);
			})
			.catch((err) => {
				console.error('[SW] Falha ao registrar:', err);
			});
	});
}

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root"),
	() => {
		// Verificar se a função existe antes de chamar
		if (typeof window.finishProgress === 'function') {
			window.finishProgress();
		}
	}
);